var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    enableBackground: "new 0 0 283.46 283.46",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M242.31,137.62v128.77c0,3.31-2.69,6-6,6H25.41 c-3.31,0-6-2.69-6-6V72.35"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 242.31,
    y1: 76.35,
    x2: 242.31,
    y2: 85.47
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M76.84,11.07h159.47c3.31,0,6,2.69,6,6v59.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M242.31,129.62"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M21.7,63.67L71.29,13.4 c4.91-4.97,13.3-1.45,13.3,5.58v50.27c0,4.36-3.49,7.9-7.79,7.9H27.21C20.27,77.15,16.8,68.64,21.7,63.67z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 46.05,
    y1: 140.31,
    x2: 185.75,
    y2: 140.31
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 165.26,
    y1: 208.17,
    x2: 215.67,
    y2: 208.17
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 46.05,
    y1: 208.17,
    x2: 134.89,
    y2: 208.17
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    points: "46.05,174.24 143.9,174.24 156.7,174.24  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    points: "215.67,164.26 215.67,242.1 46.05,242.1  46.05,106.38 215.67,106.38 215.67,110.39  "
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 96.8,
    y1: 106.38,
    x2: 96.8,
    y2: 242.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M130.85,224.11l44.19-19.22l87.11-87.11 l-26.94-26.94l-87.47,87.47l-18.87,43.82C128.33,223.39,129.6,224.65,130.85,224.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    d: "M239.47,86.59c6.66-6.66,18.08-6.03,25.52,1.41 s8.07,18.86,1.41,25.52"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 222.2,
    y1: 103.86,
    x2: 249.14,
    y2: 130.79
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 172.34,
    y1: 201.14,
    x2: 144.93,
    y2: 173.73
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#6300FF",
    strokeWidth: 13,
    strokeMiterlimit: 10,
    x1: 132.89,
    y1: 207.11,
    x2: 145.89,
    y2: 220.11
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/Create.0fef91901aaf93a8ebce711a18358168.svg";
export { ForwardRef as ReactComponent };